import Vue from 'vue';

import { round, splitDigits } from '@/utils';

Vue.filter('round', round);
Vue.filter('split', splitDigits);
